var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { fetcher } from "@/api/schema";
import { withPrefix } from "@/utils/redirect";
export const datasetsFetcher = fetcher.path("/api/datasets").method("get").create();
/** Datasets request helper **/
export function getDatasets(options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {};
        if (options.sortBy) {
            const sortPrefix = options.sortDesc ? "-dsc" : "-asc";
            params.order = `${options.sortBy}${sortPrefix}`;
        }
        if (options.limit) {
            params.limit = options.limit;
        }
        if (options.offset) {
            params.offset = options.offset;
        }
        if (options.query) {
            params.q = ["name-contains"];
            params.qv = [options.query];
        }
        const { data } = yield datasetsFetcher(params);
        return data;
    });
}
export const fetchDataset = fetcher.path("/api/datasets/{dataset_id}").method("get").create();
export const fetchDatasetStorage = fetcher.path("/api/datasets/{dataset_id}/storage").method("get").create();
export function fetchDatasetDetails(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield fetchDataset({ dataset_id: params.id, view: "detailed" });
        // We know that the server will return a DatasetDetails object because of the view parameter
        // but the type system doesn't, so we have to cast it.
        return data;
    });
}
const updateDataset = fetcher.path("/api/datasets/{dataset_id}").method("put").create();
export function undeleteDataset(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield updateDataset({
            dataset_id: datasetId,
            type: "dataset",
            deleted: false,
        });
        return data;
    });
}
const deleteDataset = fetcher.path("/api/datasets/{dataset_id}").method("delete").create();
export function purgeDataset(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield deleteDataset({ dataset_id: datasetId, purge: true });
        return data;
    });
}
const datasetCopy = fetcher.path("/api/histories/{history_id}/contents/{type}s").method("post").create();
export function copyDataset(datasetId, historyId, type = "dataset", source = "hda") {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield datasetCopy({
            history_id: historyId,
            type,
            source: source,
            content: datasetId,
        });
        return response.data;
    });
}
export function getCompositeDatasetLink(historyDatasetId, path) {
    return withPrefix(`/api/datasets/${historyDatasetId}/display?filename=${path}`);
}
export const fetchDatasetExtraFiles = fetcher.path("/api/datasets/{dataset_id}/extra_files").method("get").create();
export function fetchDatasetAttributes(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(withPrefix(`/dataset/get_edit?dataset_id=${datasetId}`));
        return data;
    });
}
